










































import { defineComponent, computed } from '@nuxtjs/composition-api';
import type { PropType } from '@nuxtjs/composition-api';
import type { ProductDescriptionSection } from '~/types/product/ProductDescription';
import { CONSENT_MANAGER_VENDOR, CONSENT_MANAGER_PURPOSE } from '~/constants/consentManager';

export default defineComponent({
  name: 'ProductDescriptionSection',
  components: {
    ThreeSixtyImage: () => import(/* webpackChunkName: "ThreeSixtyImage" */
      '~/components/molecules/Product/ThreeSixtyImage/ThreeSixtyImage.vue'),
    VideoIframe: () => import(/* webpackChunkName: "VideoIframe" */
      '~/components/atoms/VideoIframe/VideoIframe.vue'),
  },
  props: {
    section: {
      type: Object as PropType<ProductDescriptionSection>,
      required: true,
    },
    sectionIndex: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const isEven = computed(() => props.sectionIndex % 2);

    return {
      isEven,
      CONSENT_MANAGER_VENDOR,
      CONSENT_MANAGER_PURPOSE,
    };
  },
});
